<div (dragleave)="nodeDragLeaveInspector($event)">
    <ng-container>
        <ng-container *ngTemplateOutlet="nodesList; context: {nodesItems: $nodesItems(), isRoot: true, componentGraph: $node()}"></ng-container>
    </ng-container>
</div>

<ng-template #nodesList let-nodesItems="nodesItems" let-isRoot="isRoot" let-componentGraph="componentGraph">
    @for (item of nodesItems; track item.node.instanceId) {
        <cm-list-item
            (click)="selectNode(componentGraph, item.node, $event)"
            (mouseenter)="onMouseEnter(componentGraph, item.node)"
            (mouseleave)="onMouseLeave(item.node)"
            (arrowToggle)="toggleExpandedNode(item.node)"
            [selected]="item.isSelected"
            [disabled]="!item.isActive"
            [expandable]="item.isExpandable"
            [expanded]="item.isExpanded"
            [draggable]="!isMattressMesh(item.node)"
            (dragstart)="nodeDragStart($event, item.node, componentGraph)"
            (dragover)="nodeDragOver($event, item.node, componentGraph)"
            (dragend)="nodeDragEnd($event)"
        >
            <ng-container cm-pre-title>
                <div class="cm-title-icons-container">
                    <i class="cm-node-icon" [class]="item.iconClass" [class.cm-icon-disabled]="!item.isActive" [matTooltip]="item.class"></i>
                </div>
            </ng-container>
            <ng-container cm-title>{{ item.name }}</ng-container>
            @if (!isMattressMesh(item.node)) {
                <ng-container cm-icons>
                    <i [matMenuTriggerFor]="nodeMenu" matTooltip="Menu" (click)="$event.stopPropagation()" class="far fa-ellipsis-vertical"> </i>
                    <mat-menu #nodeMenu>
                        <cm-template-menu>
                            @if (isMattressComponentInstance(item.node)) {
                                @if (canEditInInstanceContext(item.node)) {
                                    <cm-template-menu-section>
                                        <ng-container cm-section>
                                            <cm-list-item (click)="setFocusedComponentInstancePath(item.node)">
                                                <ng-container cm-pre-title><i class="far fa-diagram-project"></i></ng-container>
                                                <ng-container cm-title>Graph in instance context</ng-container>
                                            </cm-list-item>
                                        </ng-container>
                                    </cm-template-menu-section>
                                }
                                <cm-template-menu-section>
                                    <ng-container cm-section>
                                        <cm-list-item (click)="duplicateMattressComponentInstance(componentGraph, item.node)">
                                            <ng-container cm-pre-title><i class="far fa-clone"></i></ng-container>
                                            <ng-container cm-title>Duplicate</ng-container>
                                        </cm-list-item>
                                    </ng-container>
                                </cm-template-menu-section>
                            }

                            @if ($selectedNodes().length > 0) {
                                <cm-template-menu-section>
                                    <ng-container cm-section>
                                        <cm-list-item (click)="createComponentGraphFromSelection(componentGraph)">
                                            <ng-container cm-pre-title><i class="far fa-diagram-project"></i></ng-container>
                                            <ng-container cm-title>Create component graph from selection</ng-container>
                                        </cm-list-item>
                                    </ng-container>
                                </cm-template-menu-section>
                            }

                            <cm-template-menu-section>
                                <ng-container cm-section>
                                    <cm-list-item class="cm-remove-icon" (click)="deleteNode(componentGraph, item.node)">
                                        <ng-container cm-pre-title><i class="far fa-trash"></i></ng-container>
                                        <ng-container cm-title>Delete</ng-container>
                                    </cm-list-item>
                                </ng-container>
                            </cm-template-menu-section>
                        </cm-template-menu>
                    </mat-menu>
                </ng-container>
            }
        </cm-list-item>
        @if (item.isComponentGraph && item.isExpanded) {
            <div class="cm-child-nodes" (dragover)="nodeDragOverChildNodes($event, item.node)">
                <ng-container *ngTemplateOutlet="nodesList; context: {nodesItems: item.subItems, isRoot: false, componentGraph: item.node}"></ng-container>
            </div>
        }
    }

    <cm-list-item [matMenuTriggerFor]="addMenu">
        <ng-container cm-pre-title>
            <div class="cm-title-icons-container">
                <i class="far fa-plus"></i>
            </div>
        </ng-container>
        <ng-container cm-title>Add node</ng-container>
    </cm-list-item>
    <mat-menu #addMenu>
        <cm-template-menu>
            <cm-template-menu-section>
                <ng-container cm-section-title>Reference Frame</ng-container>
                <ng-container cm-section>
                    <cm-list-item (click)="addMattressReferenceFrame(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$referenceFrameIcon()"></i></ng-container>
                        <ng-container cm-title>Reference Frame</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addMattressReferenceFrameInput(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$referenceFrameInputIcon()"></i></ng-container>
                        <ng-container cm-title>Reference Frame Input</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addMattressReferenceFrameExport(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$referenceFrameExportIcon()"></i></ng-container>
                        <ng-container cm-title>Reference Frame Output</ng-container>
                    </cm-list-item>
                </ng-container>
            </cm-template-menu-section>
            <cm-template-menu-section>
                <ng-container cm-section-title>Curves</ng-container>
                <ng-container cm-section>
                    <cm-list-item (click)="addMattressCurve(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$curveIcon()"></i></ng-container>
                        <ng-container cm-title>Curve</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addMattressCurveInput(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$curveInputIcon()"></i></ng-container>
                        <ng-container cm-title>Curve Input</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addMattressCurveExport(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$curveExportIcon()"></i></ng-container>
                        <ng-container cm-title>Curve Output</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addMattressComputedCurve(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$computedCurveIcon()"></i></ng-container>
                        <ng-container cm-title>Computed Curve</ng-container>
                    </cm-list-item>
                </ng-container>
            </cm-template-menu-section>
            <cm-template-menu-section>
                <ng-container cm-section-title>Numbers</ng-container>
                <ng-container cm-section>
                    <cm-list-item (click)="addNumberInput(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$numberInputIcon()"></i></ng-container>
                        <ng-container cm-title>Number Input</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addNumberValue(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$numberValueIcon()"></i></ng-container>
                        <ng-container cm-title>Number Value</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addMathOperator(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$mathOperatorIcon()"></i></ng-container>
                        <ng-container cm-title>Math Operator</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addNumberExport(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$numberExportIcon()"></i></ng-container>
                        <ng-container cm-title>Number Output</ng-container>
                    </cm-list-item>
                </ng-container>
            </cm-template-menu-section>
            <cm-template-menu-section>
                <ng-container cm-section-title>Components</ng-container>
                <ng-container cm-section>
                    <cm-list-item (click)="addMattressComponentInstance(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$componentInstanceIcon()"></i></ng-container>
                        <ng-container cm-title>Component Instance</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addMattressComponentGraph(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$componentGraphIcon()"></i></ng-container>
                        <ng-container cm-title>Component Graph</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addMattressComponentGraphGenerator(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$componentGraphGeneratorIcon()"></i></ng-container>
                        <ng-container cm-title>Component Graph Generator</ng-container>
                    </cm-list-item>
                </ng-container>
            </cm-template-menu-section>
            <cm-template-menu-section>
                <ng-container cm-section-title>Cuts</ng-container>
                <ng-container cm-section>
                    <cm-list-item (click)="addMattressCut(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$cutIcon()"></i></ng-container>
                        <ng-container cm-title>Cut</ng-container>
                    </cm-list-item>
                </ng-container>
            </cm-template-menu-section>
            <cm-template-menu-section>
                <ng-container cm-section-title>Other</ng-container>
                <ng-container cm-section>
                    <cm-list-item (click)="addMaterialInput(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$materialInputIcon()"></i></ng-container>
                        <ng-container cm-title>Material Input</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addMoveMaterial(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$moveMaterialIcon()"></i></ng-container>
                        <ng-container cm-title>Move Material</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addTemplateInput(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$templateInputIcon()"></i></ng-container>
                        <ng-container cm-title>Template Input</ng-container>
                    </cm-list-item>
                    <cm-list-item (click)="addMattressGroup(componentGraph)">
                        <ng-container cm-pre-title><i [class]="$groupIcon()"></i></ng-container>
                        <ng-container cm-title>Group</ng-container>
                    </cm-list-item>
                </ng-container>
            </cm-template-menu-section>
        </cm-template-menu>
    </mat-menu>
</ng-template>
